import React, { useRef } from 'react';
import { motion } from 'motion/react';
import cn from 'classnames';

import { useScrollText } from '../../hooks/useScrollText';
import { iconsSources } from '../../helpers/icons';
import { clearTextFromTags, hideNumber } from '../../helpers/titreHelper';

import styles from './Message.module.css';

import hum from '../../assets/images/hum.webp';

const Message = ({
  className,
  message,
  titrTag,
  setDelay,
  currentMessageRef,
  authorFontSize,
  msgFontSize,
  isScrollTextMsg,
}) => {
  const contentRef = useRef();
  const contentContainerRef = useRef();

  const isCurrent = currentMessageRef?.message?.id === message?.id;

  useScrollText(
    contentRef,
    contentContainerRef,
    message?.content,
    setDelay,
    isCurrent,
    isScrollTextMsg,
  );

  const errorHandler = (e) => {
    e.target.src = iconsSources[message?.channel] || hum;
  };

  const srcAvatar =
    (message?.image !== '1' && message?.image) ||
    iconsSources[message?.channel];

  return (
    <motion.div
      exit={{ scale: 0 }}
      transition={{ duration: 0.5, delay: 0.5 }}
      className={cn(styles.wrapper, className)}
    >
      {message && (
        <div className={styles.msgBlock}>
          <div className={styles.avatarAndName}>
            <motion.div
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              transition={{ duration: 0.5, delay: 0.5 }}
              className={styles.avatar}
            >
              <div
                className={styles.avatarBg}
                style={{
                  background: `url(${
                    iconsSources[message?.channel]
                  }) center/cover no-repeat `,
                }}
              />
              <img src={srcAvatar} alt="" onError={errorHandler} />
            </motion.div>

            <motion.div
              initial={{
                maskPosition: '100% 100%',
                WebkitMaskPosition: '100% 100%',
              }}
              animate={{
                maskPosition: '0% 100%',
                WebkitMaskPosition: '0% 100%',
              }}
              transition={{ duration: 0.4, delay: 0.5 }}
              style={{ fontSize: `${authorFontSize}rem` }}
              className={styles.name}
            >
              {message?.author || hideNumber(message?.senderNumber)}
            </motion.div>
          </div>

          <motion.div
            initial={{ scale: 0, originX: 'left', originY: 'top' }}
            animate={{ scale: 1 }}
            transition={{
              duration: 0.72,
              delay: 0.8,
              ease: 'ease-out',
            }}
            className={styles.contentAndName}
          >
            <div className={styles.content}>
              <div
                className={cn(styles.textWrapper, {
                  [styles.elipsis]: !isScrollTextMsg,
                })}
                ref={contentContainerRef}
                style={{ maxHeight: `${5 * 1.2 * msgFontSize}rem` }}
              >
                {message?.content && (
                  <div
                    className={styles.text}
                    ref={contentRef}
                    style={{
                      fontSize: `${msgFontSize}rem`,
                      lineHeight: `${1.2 * msgFontSize}rem`,
                    }}
                  >
                    {clearTextFromTags(message.content)}
                  </div>
                )}
              </div>
            </div>
          </motion.div>
        </div>
      )}
    </motion.div>
  );
};

export default React.memo(Message);
